import { IS_SERVER } from "@/constants";
export const getUrlPath = () => {
    if (IS_SERVER)
        return "";
    return window.location.pathname;
};
